export default "__VITE_ASSET__8efd7890__"